const segment = {
    journey: 'WC_Onboarding',
    product_group: 'Lending',
    product_name: 'Working_Capital',
}

export function wcDefaultSegmentProperties(){
    return segment
}